import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Empty_Protocol17025Cat_Interface, Protocol17025Cat_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Cat_Interface';

@Component({
  selector: 'app-Protocol17025Cat_Co',
  templateUrl: './Protocol17025Cat_Co.component.html',
  styleUrls: ['./Protocol17025Cat_Co.component.scss']
})
export class Protocol17025Cat_CoComponent implements OnInit {

  @Input() inner_17025_Cat: Array<Protocol17025Cat_Interface> = []
  @Output() On_Add_Action = new EventEmitter<Protocol17025Cat_Interface>();
  @Output() On_Edit_Action = new EventEmitter<Protocol17025Cat_Interface>();
  @Output() On_Remove_Action = new EventEmitter<Protocol17025Cat_Interface>();

  constructor() { }

  ngOnInit() {
  }




  OnSet_Add_Action(item: Protocol17025Cat_Interface) {
    this.On_Add_Action.emit(item);
  }

  OnSet_Edit_Action(item: Protocol17025Cat_Interface) {
    this.On_Edit_Action.emit(item);
  }

  OnSet_Remove_Action(item: Protocol17025Cat_Interface) {
    this.On_Remove_Action.emit(item);
  }

  Change_Visible(item: Protocol17025Cat_Interface) {
    item.childVisible = !item.childVisible
  }

}
